import React from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';

interface BakeasyCheckboxProps {
  label: string;
  disabled?: boolean;
  fullWidth?: boolean;
  variant?: any;
  style?: React.CSSProperties;
  value: boolean;
  required?: boolean;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

function BakeasyCheckbox(props: BakeasyCheckboxProps) {
  return (
    <FormControlLabel
      control={
        <Checkbox onClick={props?.onClick} checked={props?.value} disabled={props?.disabled} size="small" />
      }
      label={props?.label}
      required={props?.required ?? false}
      disableTypography={true}
    />
  );
}

export default BakeasyCheckbox;
